import { AUTORI, CATEGORIEFAQ, PAGINEDETAIL, SLUG } from 'utils/endpoint'
import React, { useEffect, useMemo, useState } from 'react'

import AccordionItem from 'components/atomic/AccordionItem'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import { api } from 'utils'
import BoxSportello from 'components/atomic/BoxSportello'
import Trans from 'components/atomic/Trans'
import { Actions, StickyActions } from 'react-components/organisms'

const AutoriFaq = React.memo(({ categorieFaq, autore, pagina, statusCode }) => {
  if (!autore) return <Error statusCode={statusCode} />

  const [actualFaqs, setActualFaqs] = useState([])

  useEffect(() => {
    initializePaginaFaq()
  }, [])

  const initializePaginaFaq = () => {
    if (categorieFaq.length > 0) {
      showActualFaqs()
    }
  }

  const listFaq = useMemo(
    () =>
      categorieFaq.map((categoria, index) => (
        <div
          key={categoria.id + '_titolo'}
          className={
            'faq-page__autore__category' +
            (categoria.scelta ? ' faq-page__autore__category--active' : '') +
            (index % 2 ? '' : ' faq-page__autore__category--odd')
          }
        >
          <p className={`faq-page__autore__category-title-mobile`}>{categoria.nome}</p>
          <ul className={`faq-page__autore__category-faq-list`}>
            {categoria.faqs.map(faq => (
              <li key={faq.id}>
                <AccordionItem domanda={faq.domanda} risposta={faq.risposta} />
              </li>
            ))}
          </ul>
        </div>
      )),
    [categorieFaq, actualFaqs]
  )

  const selezionaCategoria = () => {
    const categoriaDefault = categorieFaq[0]

    const hash = window.location.hash.split('#')[1]
    if (!hash) {
      return categoriaDefault
    }

    const selected = categorieFaq.filter(x => x.slug == hash)
    return selected.length ? selected[0] : categoriaDefault
  }

  const showActualFaqs = categoria => {
    if (!categoria) {
      categoria = selezionaCategoria()
    }
    categorieFaq = categorieFaq.map(categoria => {
      categoria.scelta = false
      return categoria
    })
    categoria.scelta = true
    let actualFaqs = categoria.faqs.map(faq => (
      <li key={faq.id}>
        <AccordionItem domanda={faq.domanda} risposta={faq.risposta} />
      </li>
    ))

    setActualFaqs(actualFaqs)
  }

  return (
    <>
      {autore ? (
        <>
          <MetaSeo seo={pagina.seo} />
          <main className={`faq-page`}>
            <div className="w-container">
              <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
            </div>
            <StickyActions item={autore} share />
            <header className="faq-page__header">
              <div className="w-container">
                <h1 className="faq-page__title">{autore.paginafaq?.titolo}</h1>
                <p className="faq-page__description">{autore.paginafaq?.descrizione}</p>
                {autore.esperto && autore.paginafaq && <BoxSportello autore={autore} faq />}
              </div>
            </header>

            {categorieFaq?.length ? (
              <div className="faq-page__autore__section">
                <section className="faq-page__autore__header">
                  <h3 className="faq-page__autore__header__title">
                    <Trans chiave="I temi più discussi" />
                  </h3>
                  <p className="faq-page__autore__header__abstract">
                    Leggi le risposte di {autore.nome} {autore.cognome} ai quesiti più frequenti:
                    potresti trovare quella che stai cercando!
                  </p>
                </section>

                <section className="faq-page__autore__content">
                  <aside className="faq-page__autore__menu">
                    {categorieFaq.map(categoria => (
                      <a
                        key={categoria.id + '_nome'}
                        href={'#' + categoria.slug}
                        onClick={() => showActualFaqs(categoria)}
                      >
                        <p
                          className={`faq-page__autore__menu__item ${
                            categoria?.scelta ? 'active' : ''
                          }`}
                        >
                          {categoria.nome}
                        </p>
                      </a>
                    ))}
                  </aside>
                  <section className="faq-page__autore__faqs">{listFaq}</section>
                </section>
              </div>
            ) : null}
            <div className="w-container">
              <Actions item={autore} share />
            </div>
          </main>
        </>
      ) : null}
    </>
  )
})

export const getServerSideProps = async ({ query: { slug }, res, req }) => {
  const headers = req?.headers?.cookie
    ? { cookie: req.headers.cookie, anteprima: req.headers.anteprima || false }
    : undefined

  try {
    const response = await api.get(`${AUTORI}${SLUG}${slug}/`, { headers })
    const autore = response.data

    const responsefaq = await api.get(`${CATEGORIEFAQ}?pagina_faq__utente_id=${autore.id}`, {
      headers,
    })
    const categorieFaq = await responsefaq.data.filter(c => c.faqs.length)

    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'autori-faq',
        content_type_id: autore.model,
        object_id: autore.id,
      },
    })
    const pagina = await pageResponse.data

    const toolbarProps = { toolbarPage: pagina, toolbarItem: autore }

    return { props: { categorieFaq, autore, pagina, key: autore.id, ...toolbarProps } }
  } catch (error) {
    console.log(error)
    if (res) {
      res.statusCode = 404
    }
    return { props: { statusCode: 404 } }
  }
}

export default AutoriFaq
